

export interface VATReturnState {

    cId?: string;
    period?: number;
    startDate?: string;
    endDate?: string;
    rptType?: string;
    rptSeq?: number;

    bizNo?: string;

    rptPeriod?: number;

    taxRate?: number; // 부가율

    taxableBaseInfo: {
        isOpen: boolean;
        isCloseModalOpen: boolean;
    }

    bizInfo: {
        bizNm: string; // 상호
        bizCeoNm: string; // 성명(대표자명)
        bizNo: string; // 사업자등록번호
        bizRegNo: string; // 생년월일 or 법인번호
        bizTelNo: string; // 사업장 전화번호
        bizAddrTelNo: string; // 주소지 전화번호
        bizAddr: string; // 사업장 주소
    }

    deactivate: boolean; // 메뉴바안에 기간, 신고구분등 클릭 시 비활성화

    taxBaseDetls: {
        rptType: string | number; // Enum: "PRELIMINARY" "CONFIRMED" "SMALL_BUSINESS_VAT_REDUCTION" "LATE_TAX_BASE" 신고구분(1. 예정, 2. 확정, 3. 영세율등 조기환급, 4. 기한후 과세표준)
        bankCode: number; // 은행코드
        bankNm: string; // 은행명
        bankBrchNm: string; // 은행지점명
        bankActNo: string; // 계좌번호
        cmpnClzDt: string; // 기업 폐업날짜
        cmpnClzRsn: string; // 기업 폐업 사유
        zeroRateCoopSts: boolean; // 영세율상호주의 여부
        zeroRateCoopType: number; // 영세율상호주의 타입
        zeroRateCoopIndsCode: number; // 영세율상호주의 업종코드
        zeroRateCoopCtryCode: string; // 영세율상호주의 국가코드

        indsType1: string; // 과세표준명세 - 업태1
        itmType1: string; // 과세표준명세 - 종목1
        indsCode1: number; // 과세표준명세 - 업종코드1
        amt1: number; // 과세표준명세 - 금액1

        indsType2: string; // 과세표준명세 - 업태2
        itmType2: string; // 과세표준명세 - 종목2
        indsCode2: number; // 과세표준명세 - 업종코드2
        amt2: number; // 과세표준명세 - 금액2

        indsType3: string; // 과세표준명세 - 업태3
        itmType3: string; // 과세표준명세 - 종목3
        indsCode3: number; // 과세표준명세 - 업종코드3
        amt3: number; // 과세표준명세 - 금액3

        exclItmType: string; // 과세표준명세 - 수입금액제외 - 종목
        exclIndsCode: number; // 과세표준명세 - 수입금액제외 - 업종코드
        exclAmt: number; // 과세표준명세 - 수입금액제외 - 금액

        taxableTotal: number; // 과세표준명세 합계

        exmptIndsType1: string; // 면세수입금액 - 업태1
        exmptItmType1: string; // 면세수입금액 - 종목1
        exmptIndsCode1: number; // 면세수입금액 - 업종코드1
        exmptAmt1: number; // 면세수입금액 - 금액1

        exmptIndsType2: string; // 면세수입금액 - 업태2
        exmptItmType2: string; // 면세수입금액 - 종목2
        exmptIndsCode2: number; // 면세수입금액 - 업종코드2
        exmptAmt2: number; // 면세수입금액 - 금액2

        exmptExclItmType: string; // 면세수입금액 - 수입금액제외 - 종목
        exmptExclIndsCode: number; // 면세수입금액 - 수입금액제외 - 업종코드    
        exmptExclAmt: number; // 면세수입금액 - 수입금액제외 - 금액

        taxExemptTotal: number; // 면세수입금액 합계

        invoAmt: number; // 계산서발급 및 수취명세 - 계산서발급금액
        rcptAmt: number; // 계산서발급 및 수취명세 - 수취금액
        taxAgentNm: string; // 세무대리인 성명
        taxAgentBizNo: string; // 세무대리인 사업자번호
        rptDt: string; // 신고년월일
        taxAgentTelNo: string; // 세무대리인 전화번호
        taxAgentBirthDt: string; // 세무대리인 생년월일
        bizMobTelNo: string; // 대표자 휴대전화
        bizEmail: string; // 대표자 이메일
    };

    readOnly: boolean;

    searchCheck: boolean;

    // 과세표준 및 매출세액
    // 과세
    salesInvoSpl: number;   // 세금계산서발급분(공급)
    salesInvoTax: number;   // 세금계산서발급분(세액)
    salesPurchaserInvoSpl: number;  // 매입자발행세금계산서(공급)
    salesPurchaserInvoTax: number;  // 매입자발행세금계산서(세액)
    salesCrdtCdCashRcptSpl: number;  // 신용카드,현금영수증발행분(공급)
    salesCrdtCdCashRcptTax: number;  // 신용카드,현금영수증발행분(세액)
    salesOthSpl: number;  // 기타(정규영수증외매출분)(공급)
    salesOthTax: number;  // 기타(정규영수증외매출분)(세액)

    // 영세
    salesZeroRtdInvoSpl: number; // 영세세금계산서발급분(공급)
    salesZeroRtdOtherSpl: number; // 영세기타(공급)

    salesOmtdPrelimDetls: {                   // 예정신고누락분 세부내역
        InvoSpl: number; // 과세 세금계산서 (공급)
        InvoTax: number; // 과세 세금계산서 (세액)
        othSpl: number; // 과세 기타 (공급)
        othTax: number; // 과세 기타 (세액)
        zeroRtdInvoSpl: number; // 영세 세금계산서 (공급)
        zeroRtdOtherSpl: number; // 영세 기타 (공급)
        sumSpl: number; // 예정신고누락분 합계 (공급)
        sumTax: number; // 예정신고누락분 합계 (세액)
    }
    salesBadDebtAdjTax: number;    // 대손세액가감(세액)
    salesTotalSumSpl: number; // 합계 (공급)
    salesTotalSumTax: number; // 합계 (세액)

    // 매입세액
    // 세금계산서 수취분    
    purchaseGenrSpl: number;   // 세금계산수취부분(일반매입)(공급)
    purchaseGenrTax: number;   // 세금계산수취부분(일반매입)(세액)
    purchaseExpDefTax: number;  // 세금계산수취부분(수출기업수입납부유예)(세액)
    purchaseFxdAssetSpl: number;  // 세금계산수취부분(고정자산매입)(공급)
    purchaseFxdAssetTax: number;  // 세금계산수취부분(고정자산매입)(세액)

    purchaseOmtdPrelimDetls: {
        InvoSpl: number;
        InvoTax: number;
        othDdctDetls: {
            crdtGenrSpl: number; // 신용매출전표수령/일반거래 (공급)
            crdtGenrTax: number; // 신용매출전표수령/일반거래 (세액)
            crdtFxdSpl: number; // 신용매출전표수령/고정자산거래 (공급)
            crdtFxdTax: number; // 신용매출전표수령/고정자산거래 (세액)
            dmdSpl: number;  // 의제매입세액 (공급)
            dmdTax: number;  // 의제매입세액 (세액)
            recyWasteSpl: number; // 재활용폐자원등매입세액 (공급)
            recyWasteTax: number; // 재활용폐자원등매입세액 (세액)
            txblConvTax: number; // 과세사업전환매입세액 (세액)
            InvenTax: number; // 재고매입세액 (세액)
            badDdctTax: number; // 변제대손세액 (세액)
            frgnTrstTax: number; // 외국인관광객환급세액 (세액)
            sumSpl: number; // 그밖의 공제매입세액 합계 (공급)
            sumTax: number; // 그밖의 공제매입세액 합계 (세액)
        }
        sumSpl: number; // 예정신고누락분 합계 (공급)
        sumTax: number; // 예정신고누락분 합계 (세액)
    }

    purchasePurchaserInvoSpl: number;     // 매입자발행 세금계산서(공급)
    purchasePurchaserInvoTax: number;     // 매입자발행 세금계산서(세액)

    purchaseOthDdctDetls: { // 그 밖의 공제매입 세액 세부내역       
        crdtGenrSpl: number; // 신용매출전표수령/일반거래 (공급)
        crdtGenrTax: number; // 신용매출전표수령/일반거래 (세액)
        crdtFxdSpl: number; // 신용매출전표수령/고정자산거래 (공급)
        crdtFxdTax: number; // 신용매출전표수령/고정자산거래 (세액)
        dmdSpl: number; // 의제매입세액 (공급)
        dmdTax: number; // 의제매입세액 (세액)
        recyWasteSpl: number; // 재활용폐자원등매입세액 (공급)
        recyWasteTax: number; // 재활용폐자원등매입세액 (세액)
        txblConvTax: number; // 과세사업전환매입세액 (세액)
        invTax: number; // 재고매입세액 (세액)
        badDdctTax: number; // 변제대손세액 (세액)
        frgnTrstTax: number; // 외국인관광객환급세액 (세액)
        sumSpl: number; // 그밖의 공제매입세액 합계 (공급)
        sumTax: number; // 그밖의 공제매입세액 합계 (세액)
    }

    purchaseTaxTotalSpl: number; // 매입세액 합계 (공급)
    purchaseTaxTotalTax: number; // 매입세액 합계 (세액)

    purchaseNonDdctDetls: { // 공제받지못할매입세액 세부
        nonDdctSpl: number;     // 공제받지못할매입세액(공급)
        nonDdctTax: number;     // 공제받지못할매입세액(세액)
        nonDdctCmnExmptSpl: number;  // 공통매입세액 중 면세사업등 해당 세액 (공급)
        nonDdctCmnExmptTax: number;  // 공통매입세액 중 면세사업등 해당 세액 (세액)
        nonDdctBadDebtSpl: number;  // 대손처분받은 세액 (공급)
        nonDdctBadDebtTax: number;  // 대손처분받은 세액 (세액)       
        sumSpl: number; // 공제받지못할매입세액 합계 (공급)
        sumTax: number; // 공제받지못할매입세액 합계 (세액)
    }

    // 차감계 (15 - 16)
    deductibleTotalSpl: number;
    deductibleTotalTax: number;

    // 납부(환급)세액 (㉮매출세액 - ㉯매입세액)
    payableOrRefundableTax: number;

    // 경감공제세액
    otherDdctRdctDetls: {
        elecFilingTax: number; // 전자신고 및 전자고지 (세액)
        elecTaxInvoDdctTax: number; // 전자세금발급금액 (세액)
        taxiTranspTax: number; // 택시운송 사업자 (세액)
        proxyPmtDdctTax: number; // 대리납부 세액공제 (세액)
        cashRcptBizTax: number; // 현금영수증 사업자 (세액)
        othTax: number; // 기타 (세액)
        sumTax: number; // 그 밖의 경감, 공제 세액 합계(세액)
    }

    crdtCardSalesDdctSpl: number;    // 신용카드매출전표등 발행공제 계(공급)
    crdtCardSalesDdctTax: number;    // 신용카드매출전표등 발행공제 계(세액)

    otherDdctRdctTotalSpl: number; // 경감공제세액 합계(공급)
    otherDdctRdctTotalTax: number; // 경감공제세액 합계(세액)

    // 기타 세액
    smBizVatRdctTax: number;    // 소규모 개인사업자 부가가치세 감면세액
    prelimRetUnrfndTax: number;     // 예정신고미환급세액
    exptNotiTax: number;      // 예정고지세액
    bizTransfPrepdTax: number;     // 사업양수자의 대리납부 기납부세액

    purchaserSpcPrepdTax: number;     // 매입자 납부특례 기납부세액
    crdtCardIssrPrepdTax: number;    // 신용카드업자가 대리납부한 세액

    // 가산세액계
    addTaxDetls: {
        unregBizSpl: number; // 사업자미등록 가산세 (공급)
        unregBizTax: number; // 사업자미등록 가산세 (세액)
        delayedTaxInvoIssnSpl: number; // 세금계산서 지연발급등 가산세 (공급)
        delayedTaxInvoIssnTax: number; // 세금계산서 지연발급등 가산세 (세액)
        delayedTaxInvoRcptSpl: number; // 세금계산서 지연수취 가산세 (공급)
        delayedTaxInvoRcptTax: number; // 세금계산서 지연수취 가산세 (세액)
        nonIssnTaxInvoSpl: number; // 세금계산서미발급등 가산세 (공급)
        nonIssnTaxInvoTax: number; // 세금계산서미발급등 가산세 (세액)
        delayedEtaxInvoTransmSpl: number; // 전자세금계산서 지연전송 가산세 (공급)
        delayedEtaxInvoTransmTax: number; // 전자세금계산서 지연전송 가산세 (세액)
        nonTransmETaxInvoSpl: number; // 전자세금계산서 미전송 가산세 (공급)
        nonTransmETaxInvoTax: number; // 전자세금계산서 미전송 가산세 (세액)
        taxInvoSmryNegligDetls: {
            notSubmSpl: number; // 미제출
            notSubmTax: number; // 미제출
            IncorrSpl: number; // 부실기재
            incorrTax: number; // 부실기재
            lateSpl: number; // 지연제출
            lateTax: number; // 지연제출
            notSubmAndIncorrSpl: number // 미제출 + 부실기재(공급)
            notSubmAndIncorrTax: number // 미제출 + 부실기재(세액)
        };
        rptNegligDetls: {
            nonRptGenrSpl: number; // 무신고(일반) 가산세 (공급)
            nonRptGenrTax: number; // 무신고(일반) 가산세 (세액)
            nonRptUnjustSpl: number; // 무신고(부당) 가산세 (공급)
            nonRptUnjustTax: number; // 무신고(부당) 가산세 (세액)
            underRptGenrSpl: number; // 과소.초과환급신고(일반) 가산세 (공급)
            underRptGenrTax: number; // 과소.초과환급신고(일반) 가산세 (세액)
            underRptUnjustSpl: number; // 과소.초과환급신고(부당) 가산세 (공급)
            underRptUnjustTax: number; // 과소.초과환급신고(부당) 가산세 (세액)
        };
        pmtDelaySpl: number; // 납부지연 가산세 (공급)
        pmtDelayTax: number; // 납부지연 가산세 (세액)
        zeroRateRptNegligSpl: number; // 영세율과세표준 신고불성실 가산세 (공급)
        zeroRateRptNegligTax: number; // 영세율과세표준 신고불성실 가산세 (세액)
        cashSalesStmtNonSubmSpl: number; // 현금매출명세서 미제출 가산세 (공급)
        cashSalesStmtNonSubmTax: number; // 현금매출명세서 미제출 가산세 (세액)
        realEstateRentalStmtNegligSpl: number; // 부동산임대명세서 불성실 가산세 (공급)
        realEstateRentalStmtNegligTax: number; // 부동산임대명세서 불성실 가산세 (세액)
        buyerActNonUseSpl: number; // 매입자거래계좌 미사용 가산세 (공급)
        buyerActNonUseTax: number; // 매입자거래계좌 미사용 가산세 (세액)
        buyerActDelayedDpstSpl: number; // 매입자거래계좌 지연입금 가산세 (공급)
        buyerActDelayedDpstTax: number; // 매입자거래계좌 지연입금 가산세 (세액)
        crdtCardSalesStmtNegligSpl: number; // 신용카드매출전표 등 수령명세서 미제출·과다기재 가산세 (공급)
        crdtCardSalesStmtNegligTax: number; // 신용카드매출전표 등 수령명세서 미제출·과다기재 가산세 (세액)
        sumTax: number; // 가산세액계 합계(세액)
    }

    // 최종 납부(환급)세액
    finalPayableOrRefundableTax: number;  // 납부(환급)세액(㉰-㉱-㉲-㉳-㉴-㉵-㉶)
    totTax: number;             // 총괄납부사업자 납부(환급) 세액	totalTax


}

export const initialState: VATReturnState = {

    cId: '',
    period: 0,
    startDate: '',
    endDate: '',
    rptType: 'REGULAR',
    rptSeq: 0,

    bizNo: '',

    rptPeriod: 1,

    bizInfo: {
        bizNm: '',
        bizCeoNm: '',
        bizNo: '',
        bizRegNo: '',
        bizTelNo: '',
        bizAddrTelNo: '',
        bizAddr: '',
    },

    taxableBaseInfo: {
        isOpen: false,
        isCloseModalOpen: false
    },
    deactivate: true,
    readOnly: false,
    searchCheck: false,

    taxBaseDetls: {
        rptType: '',
        bankCode: 0,
        bankNm: '',
        bankBrchNm: '',
        bankActNo: '',
        cmpnClzDt: '',
        cmpnClzRsn: '',
        zeroRateCoopSts: false,
        zeroRateCoopType: 0,
        zeroRateCoopIndsCode: 0,
        zeroRateCoopCtryCode: "",
        indsType1: '',
        itmType1: '',
        indsCode1: 0,
        amt1: 0,
        indsType2: '',
        itmType2: '',
        indsCode2: 0,
        amt2: 0,
        indsType3: '',
        itmType3: '',
        indsCode3: 0,
        amt3: 0,
        exclItmType: '',
        exclIndsCode: 0,
        exclAmt: 0,
        taxableTotal: 0,
        taxExemptTotal: 0,
        exmptIndsType1: '',
        exmptItmType1: '',
        exmptIndsCode1: 0,
        exmptAmt1: 0,
        exmptIndsType2: '',
        exmptItmType2: '',
        exmptIndsCode2: 0,
        exmptAmt2: 0,
        exmptExclItmType: '',
        exmptExclIndsCode: 0,
        exmptExclAmt: 0,
        invoAmt: 0,
        rcptAmt: 0,
        taxAgentNm: '',
        taxAgentBizNo: '',
        rptDt: '',
        taxAgentTelNo: '',
        taxAgentBirthDt: '',
        bizMobTelNo: '',
        bizEmail: '',
    },

    salesInvoSpl: 0,
    salesInvoTax: 0,
    salesPurchaserInvoSpl: 0,
    salesPurchaserInvoTax: 0,
    salesCrdtCdCashRcptSpl: 0,
    salesCrdtCdCashRcptTax: 0,
    salesOthSpl: 0,
    salesOthTax: 0,
    salesZeroRtdInvoSpl: 0,
    salesZeroRtdOtherSpl: 0,

    salesOmtdPrelimDetls: {
        InvoSpl: 0,
        InvoTax: 0,
        othSpl: 0,
        othTax: 0,
        zeroRtdInvoSpl: 0,
        zeroRtdOtherSpl: 0,
        sumSpl: 0,
        sumTax: 0
    },
    salesBadDebtAdjTax: 0,
    salesTotalSumSpl: 0,
    salesTotalSumTax: 0,

    purchaseGenrSpl: 0,
    purchaseGenrTax: 0,
    purchaseExpDefTax: 0,
    purchaseFxdAssetSpl: 0,
    purchaseFxdAssetTax: 0,

    purchaseOmtdPrelimDetls: {
        InvoSpl: 0,
        InvoTax: 0,
        othDdctDetls: {
            crdtGenrSpl: 0,
            crdtGenrTax: 0,
            crdtFxdSpl: 0,
            crdtFxdTax: 0,
            dmdSpl: 0,
            dmdTax: 0,
            recyWasteSpl: 0,
            recyWasteTax: 0,
            txblConvTax: 0,
            InvenTax: 0,
            badDdctTax: 0,
            frgnTrstTax: 0,
            sumSpl: 0,
            sumTax: 0
        },
        sumSpl: 0,
        sumTax: 0
    },
    purchasePurchaserInvoSpl: 0,
    purchasePurchaserInvoTax: 0,
    purchaseOthDdctDetls: {
        crdtGenrSpl: 0,
        crdtGenrTax: 0,
        crdtFxdSpl: 0,
        crdtFxdTax: 0,
        dmdSpl: 0,
        dmdTax: 0,
        recyWasteSpl: 0,
        recyWasteTax: 0,
        txblConvTax: 0,
        invTax: 0,
        badDdctTax: 0,
        frgnTrstTax: 0,
        sumSpl: 0,
        sumTax: 0
    },

    purchaseTaxTotalSpl: 0,
    purchaseTaxTotalTax: 0,

    purchaseNonDdctDetls: {
        nonDdctSpl: 0,
        nonDdctTax: 0,
        nonDdctCmnExmptSpl: 0,
        nonDdctCmnExmptTax: 0,
        nonDdctBadDebtSpl: 0,
        nonDdctBadDebtTax: 0,
        sumSpl: 0,
        sumTax: 0
    },

    deductibleTotalSpl: 0,
    deductibleTotalTax: 0,

    payableOrRefundableTax: 0,

    otherDdctRdctDetls: {
        elecFilingTax: 0,
        elecTaxInvoDdctTax: 0,
        taxiTranspTax: 0,
        proxyPmtDdctTax: 0,
        cashRcptBizTax: 0,
        othTax: 0,
        sumTax: 0
    },

    otherDdctRdctTotalSpl: 0,
    otherDdctRdctTotalTax: 0,

    crdtCardSalesDdctSpl: 0,
    crdtCardSalesDdctTax: 0,
    smBizVatRdctTax: 0,

    prelimRetUnrfndTax: 0,
    exptNotiTax: 0,

    bizTransfPrepdTax: 0,

    purchaserSpcPrepdTax: 0,
    crdtCardIssrPrepdTax: 0,

    addTaxDetls: {
        unregBizSpl: 0,
        unregBizTax: 0,
        delayedTaxInvoIssnSpl: 0,
        delayedTaxInvoIssnTax: 0,
        delayedTaxInvoRcptSpl: 0,
        delayedTaxInvoRcptTax: 0,
        nonIssnTaxInvoSpl: 0,
        nonIssnTaxInvoTax: 0,
        delayedEtaxInvoTransmSpl: 0,
        delayedEtaxInvoTransmTax: 0,
        nonTransmETaxInvoSpl: 0,
        nonTransmETaxInvoTax: 0,
        taxInvoSmryNegligDetls: {
            notSubmSpl: 0,
            notSubmTax: 0,
            IncorrSpl: 0,
            incorrTax: 0,
            lateSpl: 0,
            lateTax: 0,
            notSubmAndIncorrSpl: 0,
            notSubmAndIncorrTax: 0
        },
        rptNegligDetls: {
            nonRptGenrSpl: 0,
            nonRptGenrTax: 0,
            nonRptUnjustSpl: 0,
            nonRptUnjustTax: 0,
            underRptGenrSpl: 0,
            underRptGenrTax: 0,
            underRptUnjustSpl: 0,
            underRptUnjustTax: 0
        },
        pmtDelaySpl: 0,
        pmtDelayTax: 0,
        zeroRateRptNegligSpl: 0,
        zeroRateRptNegligTax: 0,
        cashSalesStmtNonSubmSpl: 0,
        cashSalesStmtNonSubmTax: 0,
        realEstateRentalStmtNegligSpl: 0,
        realEstateRentalStmtNegligTax: 0,
        buyerActNonUseSpl: 0,
        buyerActNonUseTax: 0,
        buyerActDelayedDpstSpl: 0,
        buyerActDelayedDpstTax: 0,
        crdtCardSalesStmtNegligSpl: 0,
        crdtCardSalesStmtNegligTax: 0,
        sumTax: 0
    },
    finalPayableOrRefundableTax: 0, // 최종 납부(환급)세액
    totTax: 0                      // 총괄납부사업자 납부(환급)세액
};    
